import { LogoutService } from './logout.service';
import { Dashboard } from './../../shared/interceptors/token.interceptors';
import { ModalEnvioCodigoComponent } from './../components/modal-envio-codigo/modal-envio-codigo.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Injectable, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginValidationService {
  public headers: HttpHeaders = new HttpHeaders({}).set(Dashboard, 'Dashboard');
  /**
   * Tipos de usuario
   */
  userCliente = 1011;
  userProveedor = 1012;

  /**
   * Modal para enviar código a correo para verificación
   */
  modalEnvioCodigoPrimeraVez: BsModalRef;

  constructor(
    private _http: HttpClient,
    private router: Router,
    private modalService: BsModalService,
    private _logout: LogoutService
  ) {}

  /**
   * Después de estar el usuario loggeado, se verifica si el usuario (de ser cliente o proveedor)
   * ya ha verificado su correo
   */
  validationFirstTime() {
    return this._http.get(environment.login_validacion.validacion_primera_vez, {
      headers: this.headers,
    });
  }
  /**
   * Seteando el tipo de usuario en el localstorage
   */
  setTipoUsuario(userType) {
    localStorage.setItem('uni_perms', window.btoa(JSON.stringify(userType)));
  }
  /**
   * Se chequea el tipo de usuario, si el usuario es cliente o proveedor
   * se prosigue a chequear si el usuario está entrando por primera vez.
   *
   * @param userType tipo de usuario numerico
   */
  getTipoUsuario(userType: number) {
    /**
     * Si el usuario es cliente o proveedor, se verificará si ya se validó antes o no.
     */
    if (userType === this.userCliente || userType === this.userProveedor) {
      this.validationFirstTime().subscribe(
        (res) => {
          console.log(res);

          const _continueProv = res['continueUserProv'];
          const _continueClient = res['continueUserCliente'];
          /**
           * Si el servidor responde con un 0, el usuario no podrá pasar
           * De ser 1, se envía al usuario a su dashboard
           */
          if (_continueProv === 0 || _continueClient === 0) {
            sessionStorage.setItem('primary_key', res['data']);
            console.log('Modal primera vez');
            this.openModalEnvioCodigo();
          } else {
            /**
             * De estar validado, el usuario pasa a su dashboard
             */
            this.dashboardRedireccionUsuario();
          }
        },
        (error) => {
          console.log(error);

          this._logout.logOut();
        }
      );
    } else {
      // Si el usuario es diferente a cliente o proveedor
      this.dashboardRedireccionUsuario();
    }
  }

  /**
   * Se abre el componente que contiene el modal para el envío de código
   */
  openModalEnvioCodigo() {
    this.modalEnvioCodigoPrimeraVez = this.modalService.show(ModalEnvioCodigoComponent, {
      class: 'modal-md modal-dialog-centered animated fadeIn',
      ignoreBackdropClick: true,
      keyboard: false,
    });
  }

  /**
   * Retorna un array con los tipos de rol que posee el usuario
   * El array se encuentra codificado en base64 con btoa
   * Se decodifica con atob
   */
  getUserRoles() {
    if (localStorage.getItem('uni_perms')) {
      return JSON.parse(window.atob(localStorage.getItem('uni_perms')));
    } else {
      return null;
    }
  }

  /**
   * Se manda al usuario dependiendo del tipo de usuario elegido
   */
  dashboardRedireccionUsuario() {
    const userPermissions = this.getUserRoles();
    const clientePerms = [1011];
    const proveedorPerms = [1012];

    const foundProveedor = proveedorPerms.some((r) => userPermissions.indexOf(r) >= 0);
    const foundCliente = clientePerms.some((r) => userPermissions.indexOf(r) >= 0);

    if (foundCliente) {
      // 1011 - Cliente
      this.router.navigate(['dashboard/cliente']);
    } else if (foundProveedor) {
      // 1012 - Proveedor
      this.router.navigate(['dashboard/proveedor']);
    }
  }
}
